import { extractLabel } from '#shared/utils/solr-facet'

/**
 * Resolves the `legalAreas` state for content tracking.
 * `null` means not loaded, `undefined` means loaded with no areas.
 *
 * `isLoaded` and `legalAreas` are separate because journal articles use the article
 * for access but the issue for legal areas.
 */
export function trackableLegalAreas(isLoaded: boolean, legalAreas: string[] | null | undefined): string[] | null | undefined {
  return isLoaded ? legalAreas ?? undefined : null
}

/**
 * Extract legal areas from raw facets values, which may be in the format "Name|id".
 * The name is extracted, trimmed, and deduped (by name) before being returned in a sorted array.
 */
export function extractLegalAreaNames(raw: string[] | null | undefined): string[] {
  if (!raw?.length) {
    return []
  }

  const names = raw.map(value => extractLabel(value).trim()).filter(Boolean)
  return [...new Set(names)].sort()
}
